import {
  isInternalNetworkConnectionSetupComplete,
  resolveInternalNetworkSignalSetupAvailable,
} from '@terra/ui-design-system';
import { useInternalNetworkTunnelEnrollments } from '../../../../hooks/api/useInternalNetworkConnection';
import { useInternalNetworkDiscoveryReadiness } from '../../../../hooks/api/useInternalNetworkDiscoveryStatus';
import { useInternalNetworkStats } from '../../../../hooks/api/useInternalNetworkStats';
import { useInternalNetworkEnrollments } from '../../../../hooks/api/useSurfaceSettings';
import { useFeatureFlags } from '../../../../hooks/useFeatureFlags';

export function useInternalNetworkSignalSetupAvailability(networkId: string) {
  const { stats, isLoading: isStatsLoading } =
    useInternalNetworkStats(networkId);
  const enrollmentsQuery = useInternalNetworkEnrollments(networkId);
  const tunnelEnrollmentsQuery = useInternalNetworkTunnelEnrollments({
    networkId,
  });
  const readinessQuery = useInternalNetworkDiscoveryReadiness(networkId);
  const { isFeatureFlagEnabled: isTunnelModeEnabled } = useFeatureFlags(
    'INTERNAL_NETWORK_TUNNEL_MODE_ENABLED',
  );
  const connectionMode =
    isTunnelModeEnabled && readinessQuery.data?.connectionMode === 'tunnel'
      ? 'tunnel'
      : 'sensor';
  const isLoading =
    isStatsLoading ||
    enrollmentsQuery.isLoading ||
    tunnelEnrollmentsQuery.isLoading ||
    readinessQuery.isLoading;
  const sensorSetupComplete = isInternalNetworkConnectionSetupComplete({
    enrollments: enrollmentsQuery.data?.data,
    tunnelEnrollments: tunnelEnrollmentsQuery.data?.data,
    connectionMode,
  });

  return {
    isAvailable:
      !isLoading &&
      resolveInternalNetworkSignalSetupAvailable({
        stats,
        sensorSetupComplete,
      }),
    isLoading,
  };
}
